import { PDFDocument } from 'pdf-lib';

export const countPdfPages = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();

      reader.onload = async (e) => {
        try {
          const pdfDoc = await PDFDocument.load(e.target?.result as ArrayBuffer, {
            ignoreEncryption: true
          });
          resolve(pdfDoc.getPageCount()); // Return the page count
        } catch {
          resolve(0);
        }
      };

      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    } catch {
      resolve(0);
    }
  });
};
